import { WAGEPRO_LOCALES } from '../../lib/i18n';
import type { WageProLocale } from '../../lib/i18n';

/**
 * The language choices an employee can pick, shared by the two pickers on the
 * employee surface: `EmployeeLocaleSwitcher` in the app bar and the Language
 * row on the Profile screen. One list, so the two can never offer different
 * languages or name them differently.
 *
 * Each name is the language's own name (English / සිංහල / தமிழ்) in every
 * catalog — someone who cannot read the current UI language must still be
 * able to find theirs.
 */
export const LOCALE_NAME_KEYS: Record<WageProLocale, string> = {
  'en-001': 'locale.english',
  'si-LK': 'locale.sinhala',
  'ta-LK': 'locale.tamil',
};

/**
 * `useTranslation`'s `locale` is the wider `AppLocale`; narrow it to
 * WagePro's supported set the same way `main.tsx` does at its i18n-provider
 * boundary, falling back to English for anything outside it.
 */
export function active_wagepro_locale(locale: string): WageProLocale {
  return WAGEPRO_LOCALES.find((candidate) => candidate === locale) ?? 'en-001';
}
